export default {
  id: { "ui:widget": "hidden" },
};
